import { Pipe, PipeTransform } from '@angular/core';
import {filesize, FileSizeOptions} from "filesize";


@Pipe({
  name: 'filesize',
  standalone: true
})
export class FileSizePipe implements PipeTransform {
  private static transformOne(value: number, options?: FileSizeOptions): string {
    return <string>filesize(value, options);
  }

  transform(value: number | number[], options?: FileSizeOptions) {
    if (Array.isArray(value)) {
      return value.map(val => FileSizePipe.transformOne(val, options));
    }

    return FileSizePipe.transformOne(value, options);
  }
}
